import React from "react";
import "./styles.scss";
import { GoCheck } from "react-icons/go";

interface IProps {
  checked: boolean;
  label: any;
  theam?: "dark" | "light";
  onSelect(checked: boolean): void;
}

const CheckBox = (props: IProps) => {
  return (
    <div
      className={"checkbox-wrapper"}
      onClick={() => {
        props.onSelect(!props.checked);
      }}
    >
      <div className={props.checked ? "icon checked" : "icon not-checked"}>
        {props.checked && <GoCheck />}
      </div>
      <div className="label">{props.label}</div>
    </div>
  );
};

export default CheckBox;
